module.exports = __webpack_public_path__ + "img/09.6a43ccd9.png";